"use strict";

const Dropzone = function ($wrapper, readonly = false, maxNumFiles = null) {
  var state = {
    selected: [], // added files: a File for new uploads, or a {name, ...} payload for restored ones
    existing: [], // a list of FILENAMES already existing on the server
    trash: [], // a list of filenames to be removed from the server
    readonly: readonly,
    maxNumFiles: maxNumFiles,
  };
  const uploadPromisesByFile = new WeakMap();
  var $zone = $wrapper.find(".drop-zone");
  var $singleFileUploadContainer = $wrapper.find(".single-file-upload-container");
  var $hiddenFileInput = $wrapper.find("input[name=files]");
  $hiddenFileInput.off();
  $zone.off();

  var downloadHandler = function () {
    console.warn("missing downloadHandler");
  };

  var fileSizeWarning = function () {
    console.warn("missing fileSizeWarning");
  };

  var fileTypeWarning = function (filename) {
    MessageModal.showSimpleWarningModal(
      `${filename} doesn't appear to be a supported file type. Please try uploading a document, image, spreadsheet, presentation, or zip file.`,
    );
  };

  var hiddenInputChangeCallback = function () {};

  var fileZoneDropCallback = function () {};

  var removeExistingCallback = function () {};

  var removeNewCallback = function () {};

  $hiddenFileInput.on("change", function () {
    const files = Array.from(this.files);
    if (files) {
      const filteredFiles = removeInvalidFiles(files);
      _addFiles(filteredFiles);
      $zone.html(renderHtml());
      resetHiddenFileUploadInput($(this));
    }
    hiddenInputChangeCallback();
  });

  var resetHiddenFileUploadInput = function ($input) {
    $input.val("");
  };

  // Hack! - trigger hidden file input
  $wrapper.find(".dropzone-browse").on("click", function () {
    $wrapper.find("input[name=files]").trigger("click");
  });

  $zone.on("click", ".file-list a", function () {
    var fileData = $(this).data();
    switch (fileData.action) {
      case "download-new":
        return downloadNew(fileData.name, fileData.idx);
      case "remove-new":
        return removeNew(fileData.name, fileData.idx);
      case "download-existing":
        return downloadExisting(fileData.name, fileData.idx);
      case "remove-existing":
        return _removeExisting(fileData.name, fileData.idx);
      default:
        console.log("unknown action", fileData);
    }
  });

  $singleFileUploadContainer.on("click", "[data-action]", function (event) {
    var fileData = $(this).data();
    switch (fileData.action) {
      case "download-new":
        return downloadNew(fileData.name, fileData.idx);
      case "remove-new":
        event.stopPropagation();
        return removeNew(fileData.name, fileData.idx);
      default:
        console.log("unknown action", fileData);
    }
  });

  var setupDragAndDrop = function ($zone, readonly) {
    if (readonly) return;
    $zone
      .on("dragenter", function (e) {
        e.preventDefault();
        if ($zone.is(e.target)) {
          $zone.children().hide();
          $zone.addClass("focused");
        }
      })
      .on("dragover", function (e) {
        e.stopPropagation();
        e.preventDefault();
      })
      .on("dragend dragleave", function (e) {
        e.preventDefault();
        if ($zone.is(e.target)) {
          $zone.children().show();
          $zone.removeClass("focused");
        }
      })
      .on("drop", function (e) {
        e.preventDefault();
        $zone.removeClass("focused");
        var domEvent = e.originalEvent;
        var newFiles = [];
        if (domEvent.dataTransfer.files) {
          newFiles = [...domEvent.dataTransfer.files];
          const filteredFiles = removeInvalidFiles(newFiles);
          if (filteredFiles.length > 0) {
            _addFiles(filteredFiles);
            $zone.html(renderHtml());
            fileZoneDropCallback();
          }
        }
      });
  };

  setupDragAndDrop($zone, readonly);

  var removeInvalidFiles = function (files) {
    return removeTooLargeAndShowWarning(removeFilesWithInvalidTypeAndShowWarning(files));
  };

  function removeFilesWithInvalidTypeAndShowWarning(files) {
    return files.filter((file) => {
      if (!MimeTypeFunctions.isKnownMimeType(file.type)) {
        console.log(`Tried to upload file of unsupported MIME type: ${file.type}`);
        fileTypeWarning(file.name);
        return false;
      }
      return true;
    });
  }

  function removeTooLargeAndShowWarning(files) {
    const maxUploadSize = 8 * 1024 * 1024; // 8MB
    return files.filter((file) => {
      if (file.size > maxUploadSize) fileSizeWarning(file.name);
      return file.size <= maxUploadSize;
    });
  }

  function downloadNew(name, idx) {
    FileSaver.saveAs(state.selected[idx], name);
  }

  function removeNew(name, idx) {
    state.selected.splice(idx, 1);
    $zone.html(renderHtml());

    removeNewCallback(name);
  }

  // note: maybe this should be a standard HTML link
  function downloadExisting(name) {
    downloadHandler(name);
  }

  function _removeExisting(name, idx) {
    state.existing.splice(idx, 1);
    state.trash.push(name);
    $zone.html(renderHtml());

    removeExistingCallback(name);
  }

  function _addFiles(newFiles) {
    const keptFiles = withSameNamedFilesReplaced(newFiles);
    const fileCount = keptFiles.length + state.existing.length + newFiles.length;

    if (maxNumFiles !== null && fileCount > maxNumFiles) {
      MessageModal.showSimpleWarningModal(
        `You have selected to upload ${fileCount} files. The maximum files allowed on this upload is ${maxNumFiles}.`,
      );

      return;
    }

    state.selected = keptFiles.concat(withDuplicateNamesDated(newFiles, keptFiles));
  }

  // Same-named files are normally kept side by side because the server renames them on upload, but
  // a dropzone that is already at its limit has no room for both, so re-picking a file replaces it.
  // Nothing is dropped until the whole selection is known to fit, so a rejected batch changes nothing.
  function withSameNamedFilesReplaced(newFiles) {
    if (maxNumFiles === null) {
      return state.selected;
    }

    const keptFiles = [...state.selected];

    for (const newFile of newFiles) {
      if (keptFiles.length + state.existing.length + newFiles.length <= maxNumFiles) {
        break;
      }

      const sameNamedIndex = keptFiles.findIndex((file) => file.name === newFile.name);
      if (sameNamedIndex > -1) {
        keptFiles.splice(sameNamedIndex, 1);
      }
    }

    return keptFiles;
  }

  // A file whose name is already taken here is kept as a separate file under today's date, matching
  // what the server would name it. Renaming on the way in, rather than leaving it to the server on
  // save, is what lets the file list show the name the file will really have. A removed file keeps
  // its name reserved because removing it only soft deletes it, leaving the old file on the server.
  function withDuplicateNamesDated(newFiles, keptFiles) {
    const takenNames = new Set([
      ...state.existing,
      ...state.trash,
      ...keptFiles.map((file) => file.name),
    ]);
    const renamedFiles = [];

    const datedFiles = newFiles.map(function (file) {
      if (!takenNames.has(file.name)) {
        takenNames.add(file.name);

        return file;
      }

      const datedFile = renameFile(file, getUnusedDatedName(file.name, takenNames));
      takenNames.add(datedFile.name);
      renamedFiles.push({ from: file.name, to: datedFile.name });

      return datedFile;
    });

    if (renamedFiles.length) {
      MessageModal.showDuplicateFilenameWarning(renamedFiles);
    }

    return datedFiles;
  }

  function getUnusedDatedName(filename, takenNames) {
    const extensionIndex = filename.lastIndexOf(".");
    const hasExtension = extensionIndex > 0;
    const basename = hasExtension ? filename.slice(0, extensionIndex) : filename;
    const extension = hasExtension ? filename.slice(extensionIndex) : "";
    const date = DateTime.getTodayDateString();

    for (let copy = 1; ; copy++) {
      const suffix = copy === 1 ? date : `${date}-${copy}`;
      const datedName = `${basename}-${suffix}${extension}`;

      if (!takenNames.has(datedName)) {
        return datedName;
      }
    }
  }

  function renameFile(file, name) {
    return new File([file], name, { type: file.type, lastModified: file.lastModified });
  }

  function renderHtml() {
    var html = nunjucks.render("dropzone/filelist.njk", {
      state: state,
    });
    handleSingleFileUploadDisplay();
    return html;
  }

  var handleSingleFileUploadDisplay = function () {
    if ($singleFileUploadContainer.length) {
      const $uploadButton = $singleFileUploadContainer.find(".upload-button");
      const $fileList = $singleFileUploadContainer.find(".file-list");

      if (state.selected?.length) {
        const filename = state.selected[0].name;
        $uploadButton.hide();
        $fileList.show();
        $singleFileUploadContainer.find(".file-name").text(filename);
        $singleFileUploadContainer
          .find("[data-name]")
          .data("name", filename)
          .prop("data-name", filename);
      } else {
        $uploadButton.show();
        $fileList.hide();
      }
    }
  };

  function getFiles() {
    return $.extend(true, [], state.selected);
  }

  function getRemoved() {
    return $.extend(true, [], state.trash);
  }

  function getAllFilenames() {
    return state.existing.concat(
      state.selected.map(function (f) {
        return f.name;
      }),
    );
  }

  function reset(selected, existing, trash) {
    state.selected = selected || [];
    state.existing = existing || [];
    state.trash = trash || [];
    $zone.html(renderHtml());
  }

  // function that receives a file name and returns the URL to that file
  function setDownloadHandler(func) {
    downloadHandler = func;
  }

  function setFileSizeWarning(func) {
    fileSizeWarning = func;
  }

  function setFileTypeWarning(func) {
    fileTypeWarning = func;
  }

  function setHiddenInputChangeCallback(func) {
    hiddenInputChangeCallback = func;
  }

  function setFileZoneDropCallback(func) {
    fileZoneDropCallback = func;
  }

  function setRemoveExistingCallback(func) {
    removeExistingCallback = func;
  }

  function setRemoveNewCallback(func) {
    removeNewCallback = func;
  }

  async function directUploadFiles(formKey) {
    const files = [...state.selected];

    for (const [index, file] of files.entries()) {
      if (file instanceof File) {
        files[index] = await uploadFileOnce(formKey, file);
      }
    }

    return files;
  }

  // A failed upload is forgotten so the next save retries it, while a successful one is reused to
  // keep repeated saves from uploading the same file again.
  async function uploadFileOnce(formKey, file) {
    if (!uploadPromisesByFile.has(file)) {
      const upload = createDirectUpload(formKey, file);
      upload.catch(() => uploadPromisesByFile.delete(file));
      uploadPromisesByFile.set(file, upload);
    }

    return await uploadPromisesByFile.get(file);
  }

  async function createDirectUpload(formKey, file) {
    const Form = require("./general/form");

    return Form.getDataStore(formKey)
      ? { directUpload: await Form.addFile(formKey, file), name: file.name }
      : {
          uploadedFileName: await DirectUpload.uploadFile(file, { stringKey: formKey }),
          name: file.name,
        };
  }

  return {
    reset,
    getAllFilenames,
    getFiles,
    getRemoved,
    removeNew,
    renderHtml,
    setDownloadHandler,
    setFileSizeWarning,
    setFileTypeWarning,
    setHiddenInputChangeCallback,
    setFileZoneDropCallback,
    setRemoveExistingCallback,
    setRemoveNewCallback,
    directUploadFiles,
    _addFiles,
    _removeExisting,
  };
};

module.exports = Dropzone;

const DateTime = require("./dateTime");
const MessageModal = require("./modals/messageModal");
const MimeTypeFunctions = require("./files/mimeTypeFunctions");
const DirectUpload = require("./files/directUpload");
const FileSaver = require("file-saver");
